import { getGameState, getLocalPlayer } from "./gameState";
import { updateUI, updateTeamsScore } from "./ui";

// Timer smoothing variables
let lastRoundTimeRemaining = 0;
let lastUpdateTime = 0;
let interpolatedTimeRemaining = 0;

// Update UI with current game state
export function updateGameUI(): void {
  const gameState = getGameState();
  const localPlayer = getLocalPlayer();

  if (gameState && localPlayer) {
    const { scoreElement, timerElement, teamsScoreElement } = getUIElements();

    if (scoreElement && timerElement) {
      const score = localPlayer.score;
      const teamScore = gameState.teamScores[localPlayer.team];
      const dotsRemaining = gameState.dotsRemaining || 0;
      const teamAScore = gameState.teamScores.A || 0;
      const teamBScore = gameState.teamScores.B || 0;

      // Smooth timer implementation to prevent flashing
      const now = performance.now();
      let roundTime = gameState.roundTimeRemaining;

      // If this is new data from the server
      if (roundTime !== lastRoundTimeRemaining) {
        // Update our interpolation values
        lastRoundTimeRemaining = roundTime;
        lastUpdateTime = now;
        interpolatedTimeRemaining = roundTime;
      } else {
        // Calculate elapsed time since last server update
        const elapsed = now - lastUpdateTime;

        // Only interpolate if we have valid state
        if (lastUpdateTime > 0 && interpolatedTimeRemaining > 0) {
          // Smoothly decrease timer (convert to seconds for stability)
          interpolatedTimeRemaining = Math.max(
            0,
            lastRoundTimeRemaining - elapsed
          );
        }
      }

      // Use the interpolated time for display
      roundTime = interpolatedTimeRemaining;

      updateUI(
        scoreElement,
        timerElement,
        score,
        teamScore,
        roundTime,
        localPlayer.hasRocket,
        dotsRemaining
      );

      // Update the teams score display
      if (teamsScoreElement) {
        updateTeamsScore(teamsScoreElement, teamAScore, teamBScore);
      }
    }
  }
}

/**
 * Flashes the score element to indicate points collected
 */
export function flashScoreElement(): void {
  const scoreElement = document.querySelector(
    '[style*="left: 10px"][style*="top: 10px"]'
  ) as HTMLElement;

  if (scoreElement) {
    scoreElement.style.color = "#ffff00";
    setTimeout(() => {
      scoreElement.style.color = "#ffffff";
    }, 300);
  }
}

/**
 * Gets UI elements by their position selectors
 */
export function getUIElements(): {
  scoreElement: HTMLElement | null;
  timerElement: HTMLElement | null;
  teamsScoreElement: HTMLElement | null;
} {
  const scoreElement = document.querySelector(
    '[style*="left: 10px"][style*="top: 10px"]'
  ) as HTMLElement | null;

  const timerElement = document.querySelector(
    '[style*="right: 10px"][style*="top: 10px"]'
  ) as HTMLElement | null;

  const teamsScoreElement = document.querySelector(
    '[style*="transform: translateX(-50%)"][style*="top: 10px"]'
  ) as HTMLElement | null;

  return { scoreElement, timerElement, teamsScoreElement };
}
